/**
 * Pickup at checkout (works with the "Super Sod Checkout Rules" app).
 *
 * 1. Keeps the `pickup_location` cart attribute equal to the selected store's Shopify location
 *    name, so the app's delivery customization can hide every other pickup location. Previously it
 *    was only written by the cart page / pro quick-order form at the moment of checkout.
 * 2. When the cart has pickup items, records PICK_UP as the cart's preferred delivery method just
 *    before checkout, so checkout opens on the Pickup tab instead of Ship.
 *
 * Depends on window.Scoutside.LocationState (static-init-header.js).
 */
(function () {
  const cart = window.ssPickupCart || {};
  let syncedName = cart.pickupLocation || '';

  function selectedPickupName() {
    const state = window.Scoutside && window.Scoutside.LocationState;
    if (!state || !state.selectedLocation) return '';
    const location = (state.locations || []).find(l => l.id === state.selectedLocation && l.pickup);
    return (location && location.name) || '';
  }

  function syncPickupLocation() {
    // Soil add-on orders deliberately clear the pickup attributes
    if (cart.addonForOrder) return;
    const name = selectedPickupName();
    if (!name || name === syncedName) return;
    syncedName = name;
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { pickup_location: name } })
    }).catch(() => {});
  }

  document.addEventListener('setSelectedLocation', syncPickupLocation);
  document.addEventListener('setLocationsFromAPI', syncPickupLocation);
  document.addEventListener('DOMContentLoaded', syncPickupLocation);

  async function preferPickupIfNeeded() {
    const current = await fetch('/cart.js').then(r => r.json());
    const isPickupItem = item =>
      ((item.properties && item.properties._shipping_method) || '').toLowerCase() === 'pickup' ||
      /pick\s*(it\s*)?up/i.test([item.variant_title].concat(item.variant_options || []).join(' '));
    const isPickup = (current.attributes && current.attributes.delivery_type) === 'pickup' ||
      (current.items || []).some(isPickupItem);
    if (!isPickup) return;
    await fetch('/api/2026-07/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        query: 'mutation($id: ID!, $buyer: CartBuyerIdentityInput!) { cartBuyerIdentityUpdate(cartId: $id, buyerIdentity: $buyer) { userErrors { message } } }',
        variables: {
          id: 'gid://shopify/Cart/' + current.token,
          buyer: { preferences: { delivery: { deliveryMethod: ['PICK_UP'] } } }
        }
      })
    });
  }

  // The cart page (widget-cart.js) and pro quick-order both go to checkout by POSTing the cart
  // form to /cart with `attributes[_checkout-datetime]`, then setting window.location = '/checkout'.
  // Hook that request so the preference is saved before they navigate (capped at 2.5s).
  const nativeFetch = window.fetch.bind(window);
  window.fetch = async function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const body = init && init.body;
    const response = await nativeFetch(input, init);
    const goingToCheckout = /^(https?:\/\/[^/]+)?\/cart(\?|$)/.test(url) &&
      (body instanceof URLSearchParams || body instanceof FormData) && body.has('attributes[_checkout-datetime]');
    if (goingToCheckout && response.ok) {
      await Promise.race([preferPickupIfNeeded(), new Promise(resolve => setTimeout(resolve, 2500))]).catch(() => {});
    }
    return response;
  };
})();
